import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import SingleChooseTwo from '../../components/Choose/SingleChooseTwo';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/choose/shape-4-2.png';
import shapeImg2 from '../../assets/img/choose/shape-4-1.png';
import chooseImg1 from '../../assets/img/choose/choose-4-1.jpg';
import chooseImg2 from '../../assets/img/choose/choose-4-2.jpg';
import chooseImg3 from '../../assets/img/choose/choose-4-3.jpg';

const ChooseUs = () => {
  return (
    <div
      id="it-choose"
      className="it-choose-2-area fix p-relative pt-120 pb-120"
    >
      <div className="it-choose-2-shape-2 d-none d-md-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6">
            <div className="it-choose-2-right">
              <SectionTitle
                itemClass="it-about-2-title-box mb-20"
                subTitleClass="it-section-subtitle green"
                subTitle="Why Choose Us"
                titleClass="it-section-title"
                title="The leading mental health consultations center for you."
              />
              <p className="mb-30">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod <br />
                tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="it-about-2-icon-wrap style-1">
                    <SingleChooseTwo
                      icon="flaticon-counseling"
                      title="Online Counseling"
                    />
                    <SingleChooseTwo
                      icon="flaticon-artificial-intelligence"
                      title="Group Therapy"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="it-about-2-icon-wrap style-2">
                    <SingleChooseTwo
                      icon="flaticon-doctor"
                      title="Experts Doctors"
                    />
                    <SingleChooseTwo
                      icon="flaticon-medical-report"
                      title="Medico Reports"
                    />
                  </div>
                </div>
              </div>
              <div className="it-choose-2-button mt-30">
                <Link className="it-btn-theme grey-bg" to="/about-us">
                  <Button btnText="Discover More" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="it-choose-2-thumb-wrap p-relative d-flex align-items-center justify-content-lg-end justify-content-center">
              <div className="it-choose-2-shape-1 d-none d-md-block">
                <img src={shapeImg2} alt="" />
              </div>
              <div className="it-choose-2-thumb mr-30">
                <img src={chooseImg1} alt="" />
              </div>
              <div>
                <div className="it-choose-2-thumb mb-25">
                  <img src={chooseImg2} alt="" />
                </div>
                <div className="it-choose-2-thumb">
                  <img src={chooseImg3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
